import React from 'react'
import PropTypes from 'prop-types'

import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'
import { Button, Box, Flex } from '@chatterbug/aaron'

import InfoCardSkeleton from './InfoCardSkeleton'

const InfoCard = ({
  title,
  description,
  imgUrl,
  aspectRatio,
  actionText,
  actionUrl,
}) => {
  return (
    <InfoCardSkeleton
      titleSection={title}
      descriptionSection={description}
      imageSection={
        <AspectRatioImage
          imgUrl={imgUrl}
          aspectRatio={aspectRatio}
          borderRadius="1x"
          backgroundSize="contain"
        />
      }
      actionSection={
        <Flex flexDirection={{ _: 'column', tablet: 'row' }}>
          <Button type="primaryAdvanced" href={actionUrl}>
            {actionText}
          </Button>
        </Flex>
      }
    />
  )
}

InfoCard.propTypes = {
  imgUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  aspectRatio: PropTypes.string,
  actionText: PropTypes.string,
  actionUrl: PropTypes.string,
}

export default InfoCard
